import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FishSvg } from "@/components/FishCursor";
import { useStore } from "@/context/StoreContext";

const DURATION = 2200;

export default function Preloader() {
  const { t } = useStore();
  const [show, setShow] = useState(() => !sessionStorage.getItem("nb-loaded"));

  useEffect(() => {
    if (!show) return undefined;
    const id = setTimeout(() => {
      sessionStorage.setItem("nb-loaded", "1");
      setShow(false);
    }, DURATION);
    return () => clearTimeout(id);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          exit={{ opacity: 0, scale: 1.04 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="noise fixed inset-0 z-[300] flex flex-col items-center justify-center overflow-hidden bg-black"
        >
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-ember/15 blur-[120px]" />

          <div className="relative h-24 w-[min(80vw,28rem)] overflow-visible">
            <motion.div
              initial={{ x: "-30%", y: 0 }}
              animate={{ x: "110%", y: [0, -14, 6, -10, 0], rotate: [0, -8, 4, -6, 0] }}
              transition={{ duration: 1.9, ease: "easeInOut", delay: 0.1 }}
              className="absolute top-1/2 -translate-y-1/2"
            >
              <FishSvg width={96} height={60} />
            </motion.div>
            {[0, 1, 2, 3].map((i) => (
              <motion.span
                key={i}
                initial={{ opacity: 0, scale: 0.4 }}
                animate={{ opacity: [0, 0.8, 0], scale: [0.4, 1, 1.2], y: -40 }}
                transition={{ duration: 1.2, delay: 0.5 + i * 0.3, ease: "easeOut" }}
                style={{ left: `${30 + i * 15}%`, width: 6 + i * 2, height: 6 + i * 2 }}
                className="absolute top-1/2 rounded-full border border-ember/70"
              />
            ))}
          </div>

          <motion.p
            initial={{ opacity: 0, letterSpacing: "0.6em" }}
            animate={{ opacity: 1, letterSpacing: "0.3em" }}
            transition={{ duration: 1, delay: 0.3 }}
            className="mt-6 font-display text-xl font-bold text-white sm:text-2xl"
          >
            NUSUA BETTA
          </motion.p>
          <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.35em] text-ember">
            {t.product.loading}
          </p>
          <motion.span
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: DURATION / 1000 - 0.2, ease: "linear" }}
            className="mt-6 h-px w-40 origin-left bg-gradient-to-r from-ember to-ember-light"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
